(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["levora-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-levora-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levora-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-levora-home]').forEach((home) => {
    const observer = new IntersectionObserver((entries) => { entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }); }, { threshold: 0.12 });
    home.querySelectorAll('.levora-reveal').forEach((element) => observer.observe(element));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levora-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-levora-product]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const select = section.querySelector('[data-variant-select]');
    const optionGroups = Array.from(section.querySelectorAll('[data-option-index]'));
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addLabel = section.querySelector('[data-add-label]');
    const availableText = addButton?.dataset.availableLabel || '';
    const soldOutText = addButton?.dataset.soldoutLabel || '';

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const thumb = section.querySelector(`[data-media-id="${mediaId}"]`);
      if (thumb) thumb.click();
    };

    const updateVariant = () => {
      if (!select) return;
      const values = optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue || '');
      const option = Array.from(select.options).find((item) => {
        try { return JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(values); } catch (error) { return false; }
      });
      if (!option) return;
      select.value = option.value;
      if (price) price.textContent = option.dataset.price;
      if (buttonPrice) buttonPrice.textContent = option.dataset.price;
      const isAvailable = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !isAvailable;
      if (addLabel) addLabel.textContent = isAvailable ? availableText : soldOutText;
      showMedia(option.dataset.mediaId);
      if (window.history?.replaceState) window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });
    });

    section.querySelectorAll('.levora-pdp__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const container = section.querySelector('[data-main-media]');
        const image = container?.querySelector('img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = thumb.dataset.mediaSrc;
        image.alt = thumb.dataset.mediaAlt;
        section.querySelectorAll('.levora-pdp__thumb').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
